'use strict';

var _ = require('lodash');
var XtFormValidationService = function XtFormValidationService(strategyConstants) {
  function getSingleInvalidName(xtFormError) {
    var invalidName = '';
    var requiredError = xtFormError.required;
    var patternError = xtFormError.pattern;
    if (requiredError && requiredError.length > 0) {
      if (requiredError[0].$name && requiredError[0].$name.length > 1) {
        invalidName = requiredError[0].$name;
      }
    } else if (patternError && patternError.length > 0) {
      if (patternError[0].$name && patternError[0].$name.length > 1) {
        invalidName = patternError[0].$name;
      }
    }
    return invalidName;
  }
  function getSummaryMessage(xtFormError) {
    var isValueMissing = false;
    var errorsCount = _.reduce(xtFormError, function (result, errorsArray) {
      result = result + errorsArray.length;
      if (!isValueMissing && errorsArray[0] && _.isEmpty(errorsArray[0].$viewValue)) {
        isValueMissing = true;
      }
      return result;
    }, 0);
    if (errorsCount > 1) {
      return isValueMissing ? strategyConstants.ERROR_MESSAGES.MULTIPLE_WITH_MISSING : strategyConstants.ERROR_MESSAGES.MULTIPLE;
    }
    var prefix = isValueMissing ? strategyConstants.ERROR_MESSAGES.SINGLE_MISSING : strategyConstants.ERROR_MESSAGES.SINGLE;
    var invalidName = getSingleInvalidName(xtFormError);
    invalidName = invalidName !== '' ? ': ' + invalidName + '.' : '.';
    return prefix + invalidName;
  }
  return {
    getSummaryMessage: getSummaryMessage
  };
};
XtFormValidationService.$inject = ['StrategyConstants'];
module.exports = XtFormValidationService;